<app-custom-loader class="position-absolute top-50 start-50 translate-middle" style="z-index: 6;" [isLoaderLoading]="isLoading"></app-custom-loader>
<div class="grid-thumb w-100 h-100">
  <ag-grid-angular
      id="grid"  #grid
      class="ag-theme-alpine w-100 h-100"
      [ngClass]="dataModel?.showPagination?'ag_grid_height_pagination':'h-100'"
      [defaultColDef]="defaultColDef"
      [columnDefs]="dataModel?.colDefs"
      [context]="dataModel?.context"
      [rowData]="rowData?.length ? rowData : agGridPaginationConfig.rows"
      [headerHeight]="32"
      [gridOptions]="gridOptions"
      [getRowHeight]="getRowHeight"
      [getRowStyle]="getRowStyle"
      [rowClassRules]="rowClassRules"
      [animateRows]="true"
      [suppressRowClickSelection]="true"
      [rowSelection]="dataModel?.rowSelection"
      [suppressRowTransform]="true"
      [stopEditingWhenCellsLoseFocus]="true"
      [singleClickEdit]="true"
      [suppressRowHoverHighlight]="true"
      [suppressDragLeaveHidesColumns]="true"
      [suppressColumnVirtualisation]="true"
      (selectionChanged)="onSelectionChanged($event)"
      [components]="components"
      (expandableIconClick)="expandableIconClickEvent($event)"
      [suppressNoRowsOverlay]="agGridPaginationConfig.rows.length == 0 && isLoading" 
      (gridReady)="onGridReady($event)"
      [pagination]="paginations"
      [paginationPageSize]="
        agGridPaginationConfig?.pageSize == 1
          ? agGridPaginationConfig?.totalRecords
          : agGridPaginationConfig?.pageSize
      "
      [suppressPaginationPanel]="true"
      (dragStopped)="onDragStopped($event)"
      (gridSizeChanged)="onGridSizeChanged($event)"
      [overlayNoRowsTemplate]="overlayNoRowsTemplate"
      (firstDataRendered)="onFirstDataRendered($event)"
      (rowClicked)="onRowClicked($event)"
      (columnResized)="onColumnResized($event)"
      (columnMoved)="columnMoved($event)"
      (rowSelected)="rowSelected($event)"
      (textCellClick)="handleTextCellClick($event)"
      (deleteButtonClick)="handleDeleteButtonClick($event)"
      (inputChangeClick)="handleInputChangeClick($event)"
      (imageIconClick)="handleImageIconClick($event)"
      (serialNumberClick)="handleSerialNumberClick($event)"
      (linkCellClick)="handleLinkCellClick($event)"
      (editIconClick)="handleEditIconClick($event)"
      (ratingIconClick)="handleRatingIconClick($event)"
      (switchIconClick)="handleSwitchIconClick($event)"
      (splitLineClick)="handleSplitLineClick($event)"
      (selectOptionClick)="handleSelectOptionClick($event)"
      (createPartClick)="handleCreatePartClick($event)"
      (approveAltClick)="handleApproveAltClick($event)"
      (addExchangeRateClick)="handleAddExchangeRateClick($event)"
      (resultActionClick)="handleResultActionClick($event)"
      (lineStatusClick)="handleLineStatusClick($event)"
      (addRFQClick)="handleAddRFQClick($event)"
      (removeRFQClick)="handleRemoveRFQClick($event)"
      (confirmPriorityQty)="handleConfirmPriorityQty($event)"
      (toggleApproveChange)="handleToggleApproveChange($event)"
  >
 </ag-grid-angular>

</div>

<div *ngIf="columnSettings"
  class="sideSettingButton"
>
<!-- && !(currentUrl === '/sales/requirements' && currentTab === 'requirements') -->
  <div
    class="hand px-0 py-2 mb-0"
    (click)="Customizer('layout')"
    id="c-pills-tab"
    role="tablist"
    aria-orientation=""
  >
    <!-- <app-svg-icon
      [src]="'./assets/SVGIcons/settingIcon.svg'"
      class="d-flex margin-LR"
    ></app-svg-icon> -->
    <app-svg
      class="d-flex margin-LR"
     iconType="Setting" >                        
    </app-svg>
    <p class="mx-auto m-t-10 mb-0 column-text">
      Columns
    </p>
  </div>
</div>
<app-ag-grid-columns-setting class="position-absolute d-flex" style="right:0;top:32px;height: calc(100% - 50px - 32px);"
  *ngIf="customizer != ''" [dataModel]="paramsData" [storageName]="dataModel?.storageName"
></app-ag-grid-columns-setting>
<!-- <app-columns-settings *ngIf="customizer != ''"  (onColumnVisibility)="onDrag($event)" [dataModel]="paramsData"></app-columns-settings> -->

<!-- Pagination  -->
<div *ngIf="paginations" class="d-flex align-items-center h-50px" [ngClass]="footerHeight">
  <div
    class="pagination-control"
    [ngClass]="deviceWidth < 1200 ? 'pagination-start' : 'pagination-center'"
  >
    <ngb-pagination
      #ngbPage
      [boundaryLinks]="false"
      [collectionSize]="
        agGridPaginationConfig?.totalRecords == 0
          ? 1
          : agGridPaginationConfig?.totalRecords
      "
      [pageSize]="
        agGridPaginationConfig?.pageSize == 1
          ? agGridPaginationConfig?.totalRecords
          : agGridPaginationConfig?.pageSize
      "
      [(page)]="agGridPaginationConfig.pageNumber"
      [maxSize]="deviceWidth > 768 ? 5 : 2"
      (pageChange)="onPageChanged($event)"
    >
      <ng-template ngbPaginationPrevious>&#8810;</ng-template>
      <ng-template ngbPaginationNext>&#8811;</ng-template>
    </ngb-pagination>
  </div>
  <div class="d-flex align-self-center justify-content-end flex-grow-1" >
    <select
      class="b-r-5 text-primary-color px-1 hand font-11"
      [(ngModel)]="agGridPaginationConfig.pageSize"
      (ngModelChange)="onPageSizeChange($event)"
    >
      <option
        *ngFor="let option of agGridPaginationConfig.limitOptions"
        [ngValue]="option.value"
      >
        {{ option.key }}
      </option>
    </select>
    <label class="font-12 m-b-0 m-l-5 d-flex text-light-gray align-items-center"
      >Records Per Page</label
    >
  </div>
</div>


<!-- <app-ag-grid-columns-setting *ngIf="AgGridColumnsSettingComponent"  (onColumnVisibility)="onDrag($event)" [dataModel]="paramsData"></app-ag-grid-columns-setting> -->


